// extracted by mini-css-extract-plugin
export var modal = "_bt-0";